export default __webpack_public_path__ + "static/media/leftArrow.658b02ac.svg";